import { useContext } from "react";
import { InstallPromptContext } from "./InstallPromptContext";
import { isIOS } from "./detectPlatform";

import {
  Slide,
  Paper,
  Typography,
  Button,
  Box,
  IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

export default function InstallPromptBar({ visible }) {
  const context = useContext(InstallPromptContext);
  
  if (!context) {
    console.error("[PWA Install Bar] Context não encontrado! Certifique-se de que InstallPromptProvider está envolvendo o app.");
    return null;
  }

  const {
    deferredPrompt,
    showInstallUI,
    dismiss,
    setDeferredPrompt,
  } = context;

  console.log("[PWA Install Bar] Renderizando - showInstallUI:", showInstallUI, "visible:", visible, "deferredPrompt:", !!deferredPrompt);

  if (!showInstallUI || !visible) {
    console.log("[PWA Install Bar] Não renderizando - showInstallUI:", showInstallUI, "visible:", visible);
    return null;
  }

  const handleInstall = async () => {
    console.log("[PWA Install Bar] Botão Instalar clicado");
    
    if (!deferredPrompt) {
      console.warn("[PWA Install Bar] deferredPrompt não disponível, mostrando instruções");
      // Sem deferredPrompt, mostrar instruções manuais
      alert("Para instalar o app, use o menu do navegador (três pontos) e selecione 'Adicionar à tela inicial' ou 'Instalar app'");
      dismiss();
      return;
    }

    try {
      console.log("[PWA Install Bar] Chamando deferredPrompt.prompt()");
      deferredPrompt.prompt();
      const result = await deferredPrompt.userChoice;
      console.log("[PWA Install Bar] Resultado do prompt:", result);

      if (result.outcome === "accepted") {
        console.log("[PWA Install Bar] PWA instalado com sucesso");
      } else {
        console.log("[PWA Install Bar] PWA instalação recusada pelo usuário");
      }
      
      // Limpar o deferredPrompt após uso
      setDeferredPrompt(null);
    } catch (error) {
      console.error("[PWA Install Bar] Erro ao chamar prompt:", error);
      alert("Erro ao instalar. Use o menu do navegador para instalar manualmente.");
    }

    dismiss();
  };

  const isIosDevice = isIOS();

  return (
    <Slide in={true} direction="down">
      <Paper
        elevation={2}
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2000,
          borderRadius: 0,
          background: "#ffffffdd",
          backdropFilter: "blur(4px)",
          px: 2,
          py: 1.5,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1.5,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Box display="flex" flexDirection="column" flex={1} gap={0.5}>
          <Typography variant="body2" fontWeight={500} sx={{ fontSize: '0.875rem' }}>
            {isIosDevice ? (
              <>
                Toque em <strong>Compartilhar</strong> → <strong>"Adicionar à Tela de Início"</strong>
              </>
            ) : (
              "Instale este aplicativo para acesso mais rápido e melhor experiência."
            )}
          </Typography>
        </Box>

        <Box display="flex" gap={1} alignItems="center">
          {!isIosDevice && (
            <Button
              variant="contained"
              size="small"
              onClick={handleInstall}
              sx={{ 
                minWidth: 'auto',
                px: 2,
                py: 0.75,
                fontSize: '0.8125rem',
                textTransform: 'none',
                borderRadius: 1.5,
              }}
            >
              Instalar
            </Button>
          )}
          <IconButton 
            size="small" 
            onClick={dismiss}
            sx={{ 
              p: 0.5,
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.05)' }
            }}
          >
            <CloseIcon sx={{ fontSize: '1.125rem' }} />
          </IconButton>
        </Box>
      </Paper>
    </Slide>
  );
}
